import { render, staticRenderFns } from "./menuThird.vue?vue&type=template&id=107f3edf&scoped=true"
import script from "./menuThird.vue?vue&type=script&lang=js"
export * from "./menuThird.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107f3edf",
  null
  
)

export default component.exports